import styled from 'styled-components';

export const RadioButton = styled.label`
  display: inline-flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-right: 3rem;
  user-select: none;
  .checkmark {
    position: relative;
    display: flex;
    height: 2rem;
    width: 2rem;
    background-color: white;
    border-radius: 50%;
    border: 2px solid #2276e3;
    margin-right: 1.5rem;
    &:after {
      display: none;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      background: #2276e3;
      transform: translate(-50%, -50%);
    }
  }
  .radioLabel {
    font-size: 1.4rem;
    color: black;
    font-weight: bold;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:checked ~ .checkmark {
      background-color: white;
      &:after {
        display: block;
      }
    }
  }
`;
